import { PatientLink } from "@/components/PatientLink/PatientLink";
import { Text } from "@medoma/components/Text/Text";
import {
  formatPersonalIdentityNumber,
  patientStatusSchema,
} from "@medoma/models/patients";
import type { IListPatient } from "@/api/Patients";
import styles from "./PatientHeader.module.scss";

type PatientHeaderProps = {
  patient: IListPatient;
};

export const PatientHeader = ({ patient }: PatientHeaderProps) => (
  <div className={styles.patientHeader}>
    <PatientLink patient={patient} size="large" weight="bold" />
    {patient.status !== patientStatusSchema.enum.deleted ? (
      <div className={styles.patientMeta}>
        <Text element="span" size="small" color="faded">
          {formatPersonalIdentityNumber({
            personalIdentityNumber: patient.personalIdentityNumber,
            personalIdentityNumberType: patient.personalIdentityNumberType,
          })}
        </Text>
        {patient.area ? (
          <>
            <div className={styles.separator} />
            <Text element="span" size="small" color="faded">
              {patient.area.displayName}
            </Text>
          </>
        ) : null}
      </div>
    ) : null}
  </div>
);
